"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Here is a list of the toolbar
// Detail list see https://www.tinymce.com/docs/advanced/editor-control-identifiers/#toolbarcontrols

var toolbar = ['Upload searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent blockquote undo redo removeformat ', 'subscript superscript code  codesample fontsizeselect  fontselect hr bullist numlist link charmap preview anchor ', 'pagebreak insertdatetime   media table emoticons forecolor backcolor fullscreen'];
var _default = exports.default = toolbar;